import React from "react";
import { HiOutlinePlus, HiOutlineChevronRight } from "react-icons/hi";
import { useHistory } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import API from "../../api";
import { capture } from "../../instrument";
import PageLoadingSpinner from "../../components/PageLoadingSpinner";

const Network = () => {
  const history = useHistory();

  const {
    data: networks = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["networks"],
    queryFn: async () => {
      const response = await API.get("/admin/network");
      if (!response.ok) {
        const error = new Error(response.message);
        capture(error);
        throw error;
      }
      return response.data;
    },
  });

  if (isLoading) return <PageLoadingSpinner />;

  if (isError) {
    return (
      <div className="flex min-h-[calc(100vh-60px)] flex-col items-center justify-center gap-3 bg-gray-50">
        <span className="text-sm text-red-500">Erreur lors du chargement des réseaux</span>
      </div>
    );
  }

  return (
    <div className="h-[calc(100vh-60px)] bg-gray-50 p-6">
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-xl font-semibold text-gray-900">Réseaux</h1>
        <button
          type="button"
          className="flex items-center gap-2 rounded-lg bg-primary-500 px-3 py-1.5 text-sm text-white transition-colors hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
          onClick={() => history.push("/network/add")}
        >
          <HiOutlinePlus className="h-4 w-4" />
          <span>Nouveau réseau</span>
        </button>
      </div>

      <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
        {networks.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-16 text-gray-400">
            <p className="text-sm">Aucun réseau</p>
            <p className="mt-1 text-xs">Créez-en un en cliquant sur le bouton ci-dessus</p>
          </div>
        ) : (
          <div className="max-h-[calc(100vh-180px)] overflow-y-auto">
            {networks.map((network) => (
              <div
                key={network._id}
                className="flex cursor-pointer items-center gap-4 border-b border-gray-100 px-5 py-4 last:border-b-0 hover:bg-gray-50"
                onClick={() => history.push(`/network/${network._id}/edit`)}
              >
                <span className="w-48 shrink-0 truncate text-sm font-medium text-gray-900">{network.name}</span>
                <div className="flex min-w-0 flex-1 flex-wrap gap-1.5">
                  {network.origins.map((origin) => (
                    <code key={origin} className="rounded bg-gray-100 px-2 py-0.5 font-mono text-xs text-gray-600">
                      {origin}
                    </code>
                  ))}
                </div>
                <span className="shrink-0 text-xs text-gray-400">
                  {network.indexNames.length} indexName{network.indexNames.length > 1 ? "s" : ""}
                </span>
                <HiOutlineChevronRight className="h-4 w-4 shrink-0 text-gray-300" />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Network;
